module.exports = __webpack_public_path__ + "static/media/TnBaixa.7f91bf54.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/TnBaixa.svg
// module id = 217
// module chunks = 0